import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

function Payment() {

    const { ref_no } = useParams();
    const navigate = useNavigate();

    const [booking, setBooking] = useState(null);
    const [loading, setLoading] = useState(true);
    const [timer, setTimer] = useState('');
    const [paymentLoading, setPaymentLoading] = useState(false);



    // =========================
    // FETCH BOOKING
    // =========================

    useEffect(() => {

        fetchBooking();

    }, []);

    const fetchBooking = async () => {

        try {

            const res = await fetch(
                `https://orisoftpl.com/backend/api/frontend/booking/payment/${ref_no}`
            );

            const data = await res.json();

            if (!res.ok) {

                Swal.fire({
                    icon: 'error',
                    title: 'Booking Not Found',
                    text: data.message,
                });

                navigate('/');

                return;
            }

            setBooking(data.booking);

        } catch (error) {

            console.log(error);

            Swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: 'Something went wrong',
            });

        } finally {

            setLoading(false);
        }
    };

    // =========================
    // TIMER
    // =========================

    useEffect(() => {

        if (!booking?.payment_expires_at) return;

        const interval = setInterval(() => {

            const now = new Date().getTime();

            const expiry = new Date(
                booking.payment_expires_at
            ).getTime();

            const distance = expiry - now;

            if (distance <= 0) {

                clearInterval(interval);

                setTimer('Expired');

                return;
            }

            const minutes = Math.floor(
                (distance % (1000 * 60 * 60)) / (1000 * 60)
            );

            const seconds = Math.floor(
                (distance % (1000 * 60)) / 1000
            );

            setTimer(
                `${minutes}:${seconds.toString().padStart(2, '0')}`
            );

        }, 1000);

        return () => clearInterval(interval);

    }, [booking]);

    // =========================
    // PAYMENT SUCCESS
    // =========================

    const handlePayment = async () => {

        try {

            setPaymentLoading(true);

            const res = await fetch(
                'https://orisoftpl.com/backend/api/frontend/booking/payment/success',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    body: JSON.stringify({
                        ref_no: booking.booking_ref,
                    }),
                }
            );

            const data = await res.json();

            if (!res.ok) {

                Swal.fire({
                    icon: 'error',
                    title: 'Payment Failed',
                    text: data.message,
                });

                return;
            }

            Swal.fire({
                icon: 'success',
                title: 'Payment Successful',
                text: 'Booking submitted successfully',
                timer: 2500,
                showConfirmButton: false,
            });

            setTimeout(() => {

                navigate(`/booking-status/${booking.booking_ref}`);

            }, 2500);

        } catch (error) {

            console.log(error);

            Swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: 'Something went wrong',
            });

        } finally {

            setPaymentLoading(false);
        }
    };

    // =========================
    // LOADING
    // =========================

    if (loading) {

        return (
            <div className='min-h-screen flex items-center justify-center text-2xl font-bold'>
                Loading...
            </div>
        );
    }

    return (

        <div className="min-h-screen bg-gray-200 flex items-center justify-center p-6">

            <div className="w-full max-w-5xl rounded-3xl overflow-hidden shadow-2xl bg-white grid grid-cols-1 md:grid-cols-[380px_1fr]">

                {/* LEFT PANEL */}
                <div className="bg-gradient-to-br from-blue-500 to-blue-800 text-white p-8 relative overflow-hidden">

                    <div className="absolute -bottom-16 -left-10 w-[400px] h-[180px] bg-blue-400/20 rounded-full rotate-12"></div>

                    <div className="absolute bottom-0 right-0 w-[320px] h-[140px] bg-blue-300/10 rounded-full"></div>

                    <div className="relative z-10">

                        {/* HEADER */}
                        <div className="flex items-center justify-between mb-10">

                            <div className="flex items-center gap-4">

                                <div className="w-20 h-20 rounded-xl bg-gray-100 text-gray-700 flex items-center justify-center text-3xl font-serif shadow-lg">
                                    {booking?.mandap?.name?.charAt(0)}
                                </div>

                                <div>
                                    <h2 className="text-3xl font-bold tracking-wide">
                                        {booking?.mandap?.name}
                                    </h2>

                                    <p className='text-sm opacity-80 mt-1'>
                                        Mandap Booking Portal
                                    </p>
                                </div>

                            </div>

                            {/* <select className="bg-white/20 border border-white/30 rounded-lg px-3 py-2 text-sm outline-none">
                                <option>EN</option>
                                <option>HI</option>
                            </select> */}

                        </div>

                        {/* ORDER */}
                        <div className="mb-8">

                            <p className="text-sm opacity-80">
                                Booking Reference
                            </p>

                            <h3 className="text-2xl font-bold tracking-wide mt-1">
                                {booking?.booking_ref}
                            </h3>

                        </div>

                        {/* USER DETAILS */}
                        <div className="bg-white/10 border border-white/20 rounded-2xl p-5 mb-5 backdrop-blur-sm">

                            <h4 className='text-lg font-semibold mb-4'>
                                Booking Details
                            </h4>

                            <div className='space-y-2 text-sm'>

                                <div className='flex justify-between'>
                                    <span className='opacity-80'>Customer</span>
                                    <span>{booking?.name}</span>
                                </div>

                                <div className='flex justify-between'>
                                    <span className='opacity-80'>Mobile</span>
                                    <span>{booking?.mobile}</span>
                                </div>

                                <div className='flex justify-between'>
                                    <span className='opacity-80'>From Date</span>
                                    <span>{booking?.from_date}</span>
                                </div>

                                <div className='flex justify-between'>
                                    <span className='opacity-80'>To Date</span>
                                    <span>{booking?.to_date}</span>
                                </div>

                                <div className='flex justify-between'>
                                    <span className='opacity-80'>Purpose</span>
                                    <span>
                                        {booking?.purpose_other
                                            ? booking?.purpose_other
                                            : booking?.purpose?.name
                                        }
                                    </span>
                                </div>

                            </div>

                        </div>

                        {/* SUMMARY */}
                        <div className="space-y-4">

                            <div className="bg-white/10 border border-white/20 rounded-2xl p-5 backdrop-blur-sm">

                                <p className="text-lg font-medium mb-2">
                                    Order Summary
                                </p>

                                <div className="flex justify-between items-center mt-4">
                                    <span className="opacity-80">
                                        Booking Amount
                                    </span>

                                    <span>
                                        ₹ {booking?.mandap?.booking_amount}
                                    </span>
                                </div>

                                <div className="flex justify-between items-center mt-2">
                                    <span className="opacity-80">
                                        User Fee
                                    </span>

                                    <span>
                                        ₹ {booking?.mandap?.user_fee}
                                    </span>
                                </div>

                                <div className="border-t border-white/20 mt-4 pt-4 flex justify-between items-center font-bold text-2xl">

                                    <span>Total</span>

                                    <span>
                                        ₹ {booking?.price}
                                    </span>

                                </div>

                            </div>

                        </div>

                        {/* FOOTER */}
                        <div className="mt-20 flex items-center justify-between text-sm opacity-80">

                            <span>Secured by CCAvenue</span>

                            <span>PCI DSS</span>

                        </div>

                    </div>
                </div>

                {/* RIGHT PANEL */}
                <div className="bg-gray-50 p-8 flex flex-col justify-between">

                    <div>

                        {/* TITLE */}
                        <div className="flex items-center justify-between border-b pb-4 mb-8">

                            <h2 className="text-3xl font-bold text-gray-800">
                                UPI Payment
                            </h2>

                            <button
                                onClick={() => navigate('/')}
                                className="text-3xl text-gray-500 hover:text-red-500 transition-all"
                            >
                                ×
                            </button>

                        </div>

                        {/* SUB TITLE */}
                        <h3 className="text-2xl font-semibold text-gray-800 mb-6">
                            Pay through UPI QR Code
                        </h3>

                        {/* QR SECTION */}
                        <div className="bg-white border rounded-3xl p-6 shadow-sm flex flex-col md:flex-row gap-8 items-center">

                            {/* QR */}
                            <div className="bg-white p-4 border rounded-2xl shadow-sm">

                                <img
                                    src={`https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=upi://pay?pa=demo@upi&pn=${booking?.mandap?.name}&am=${booking?.price}`}
                                    alt="QR"
                                    className="w-[220px] h-[220px]"
                                />

                            </div>

                            {/* PAYMENT DETAILS */}
                            <div className="flex-1 w-full">

                                <h4 className="text-2xl font-bold text-gray-800">
                                    Scan and Pay
                                </h4>

                                <p className="text-gray-500 mt-2 leading-relaxed">
                                    Scan this QR code using any UPI application
                                    like Google Pay, PhonePe, Paytm, BHIM or
                                    Amazon Pay.
                                </p>

                                {/* APPS */}
                                <div className="flex gap-3 mt-6 flex-wrap">

                                    <div className="px-4 py-2 rounded-xl bg-blue-100 text-blue-700 font-semibold text-sm">
                                        GPay
                                    </div>

                                    <div className="px-4 py-2 rounded-xl bg-purple-100 text-purple-700 font-semibold text-sm">
                                        PhonePe
                                    </div>

                                    <div className="px-4 py-2 rounded-xl bg-cyan-100 text-cyan-700 font-semibold text-sm">
                                        Paytm
                                    </div>

                                    <div className="px-4 py-2 rounded-xl bg-orange-100 text-orange-700 font-semibold text-sm">
                                        BHIM
                                    </div>

                                </div>

                                {/* TIMER */}
                                <div className="mt-8 bg-yellow-50 border border-yellow-200 rounded-2xl p-4">

                                    <p className="text-sm text-gray-600">
                                        QR expires in
                                    </p>

                                    <h4 className="text-3xl font-bold text-yellow-700 mt-1">
                                        {timer}
                                    </h4>

                                </div>

                                {/* BUTTON */}
                                <button
                                    onClick={handlePayment}
                                    disabled={paymentLoading || timer === 'Expired'}
                                    className="
                                    w-full
                                    mt-8
                                    bg-blue-600
                                    hover:bg-blue-700
                                    transition-all
                                    text-white
                                    py-4
                                    rounded-2xl
                                    font-semibold
                                    text-lg
                                    shadow-lg
                                    disabled:bg-gray-400
                                    "
                                >
                                    {
                                        paymentLoading
                                            ? 'Processing Payment...'
                                            : timer === 'Expired'
                                                ? 'Payment Expired'
                                                : 'I Have Completed Payment'
                                    }
                                </button>

                            </div>

                        </div>

                        {/* POLICY */}
                        <div className="mt-10 text-center text-sm text-gray-500 hover:text-blue-600 cursor-pointer transition-all">
                            Privacy Policy
                        </div>

                    </div>

                    {/* FOOTER */}
                    <div className="mt-10 border-t pt-6 flex items-center justify-between">

                        <div>

                            <p className="text-sm text-gray-500">
                                Payable Amount
                            </p>

                            <h2 className="text-4xl font-bold text-gray-800 mt-1">
                                ₹ {booking?.price}
                            </h2>

                        </div>

                        <button className="bg-gray-900 hover:bg-black text-white px-8 py-4 rounded-2xl font-semibold shadow-lg transition-all">
                            View Summary
                        </button>

                    </div>

                </div>
            </div>
        </div>
    );
}

export default Payment;